import moment from "moment";

export const CampaignReportHeaders = [
  { label: "Date", key: "date" },
  { label: "Campaign", key: "campaign" },
  { label: "Type", key: "type" },
  { label: "Driver Name", key: "name" },
  { label: "Metro", key: "metro" },
  { label: "Status", key: "status" },
];

export function formatBCampaignReportTransactions(data) {
  const formattedData = data.map((item) => {
    const {
      campaign,
      username,
      name,
      metro,
      bonusStatus,
      date,
    } = item || {};

    return {
      campaign: campaign?.name || "-",
      type: campaign?.type || "-",
      name: name || "-",
      username: username || "-",
      metro: metro || "-",
      status: bonusStatus || "-",
      date: moment(date).format('MM-DD-YYYY hh:mm A'),
    };
  }) || [];

  return formattedData;
}